import { Chip, ChipProps } from '@mui/material';
import React from 'react';

interface MuiChipProps extends Omit<ChipProps, 'color'> {
    color?: 'purple' | 'default';
}

export const MuiChip: React.FC<MuiChipProps> = ({ color, sx, size = 'small', ...props }) => {
    const colorProps = React.useMemo(() => {
        switch (color) {
            case 'purple':
                return {
                    backgroundColor: 'purple.tertiary',
                    color: 'black.tertiary'
                };
            default:
                return {};
        }
    }, [color]);
    return (
        <Chip
            {...props}
            size={size}
            sx={{
                ...colorProps,
                ...sx
            }}
        />
    );
};
